<template>
  <div class="mt-3 pb-4 mb-4 font-jumper">
    <b-container
      fluid
      id="employee-sick-leave-container"
      class="employee-sick-leave pt-4 col-12"
    >
      <b-row>
        <b-col class="ml-0 profile-input-container" cols="12">
          <div class="employee-layout">
            <section
              class="employee-section-card"
              aria-label="Új betegszabadság/táppénz rögzítése"
            >
              <header class="employee-section-header">
                <h2
                  id="new-sick-leave-heading"
                  class="employee-section-title d-none d-md-block"
                >
                  Új betegszabadság/táppénz rögzítése
                </h2>
                <button
                  type="button"
                  class="employee-section-toggle d-md-none"
                  aria-controls="new-sick-leave-panel"
                  :aria-expanded="String(newSickLeaveOpen)"
                  @click="newSickLeaveOpen = !newSickLeaveOpen"
                >
                  <span>Új betegszabadság/táppénz rögzítése</span>
                  <b-icon
                    :icon="newSickLeaveOpen ? 'chevron-up' : 'chevron-down'"
                    aria-hidden="true"
                  ></b-icon>
                </button>
              </header>

              <b-collapse
                id="new-sick-leave-panel"
                v-model="newSickLeaveOpen"
                class="employee-section-body"
              >
                <div class="employee-fields-grid">
                  <span class="employee-field-full employee-field-hint">
                    Kérlek, az orvosi papíron található dátumokat írd be!
                  </span>

                  <div class="data-wrapper">
                    <label
                      class="employee-field-label employee-field-title"
                      for="employee-sick-leave-start"
                    >
                      Betegszabadság/táppénz kezdete
                    </label>
                    <DatePicker
                      id="employee-sick-leave-start"
                      v-model="newSickLeave.startDate"
                      format="YYYY-MM-DD"
                      value-type="format"
                      class="employee-date-picker white-input"
                      aria-label="Betegszabadság/táppénz kezdete"
                    />
                  </div>

                  <div class="data-wrapper">
                    <label
                      class="employee-field-label employee-field-title"
                      for="employee-sick-leave-end"
                    >
                      Betegszabadság/táppénz vége
                    </label>
                    <DatePicker
                      id="employee-sick-leave-end"
                      v-model="newSickLeave.endDate"
                      format="YYYY-MM-DD"
                      value-type="format"
                      class="employee-date-picker white-input"
                      aria-label="Betegszabadság/táppénz vége"
                    />
                  </div>

                  <span class="employee-field-full employee-field-hint">
                    Kérlek, az orvosi papíron található kódot írd be ide
                  </span>

                  <div class="data-wrapper">
                    <label
                      class="employee-field-label employee-field-title"
                      for="employee-sick-leave-code"
                    >
                      Betegszabadság/táppénz kódja
                    </label>
                    <b-form-input
                      id="employee-sick-leave-code"
                      v-model="newSickLeave.code"
                      autocomplete="off"
                      aria-label="Betegszabadság/táppénz kódja"
                    />
                  </div>

                  <div class="employee-field-full employee-form-actions">
                    <BaseButton
                      variant="success"
                      label="Rögzítés"
                      @click="saveNewSickLeave"
                    />
                  </div>
                </div>
              </b-collapse>
            </section>

            <section
              v-if="sickLeaves.length"
              class="employee-section-card"
              aria-label="Rögzített betegszabadság/táppénz"
            >
              <header class="employee-section-header">
                <h2
                  id="saved-sick-leaves-heading"
                  class="employee-section-title d-none d-md-block"
                >
                  Rögzített betegszabadság/táppénz
                </h2>
                <button
                  type="button"
                  class="employee-section-toggle d-md-none"
                  aria-controls="saved-sick-leaves-panel"
                  :aria-expanded="String(savedSickLeavesOpen)"
                  @click="savedSickLeavesOpen = !savedSickLeavesOpen"
                >
                  <span>Rögzített betegszabadság/táppénz</span>
                  <b-icon
                    :icon="savedSickLeavesOpen ? 'chevron-up' : 'chevron-down'"
                    aria-hidden="true"
                  ></b-icon>
                </button>
              </header>

              <b-collapse
                id="saved-sick-leaves-panel"
                v-model="savedSickLeavesOpen"
                class="employee-section-body"
              >
                <div class="employee-table-wrapper">
                  <b-table
                    class="employee-table"
                    responsive
                    striped
                    hover
                    :items="sickLeaves"
                    :fields="config.tableFields"
                  >
                    <template #cell(id)="data">
                      <BaseButton
                        variant="light"
                        size="sm"
                        icon="trash"
                        icon-only
                        aria-label="Törlés"
                        @click="() => deleteSickLeave(data.item.id)"
                      />
                    </template>
                  </b-table>
                </div>
              </b-collapse>
            </section>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Api from "@/api/server/index";
import BaseButton from "@/components/BaseButton.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/locale/hu";

export default {
  name: "EmployeeSickLeave",

  components: { BaseButton, DatePicker },

  props: {
    employeeId: Number,
  },

  data() {
    return {
      config: {
        tableFields: [
          {
            key: 'startDate',
            label: 'Kezdő dátum'
          },
          {
            key: 'endDate',
            label: 'Vég dátum'
          },
          {
            key: 'code',
            label: 'Kód'
          },
          {
            key: 'id',
            label: 'Törlés'
          }
        ]
      },

      newSickLeaveOpen: !this.isMobile(),
      savedSickLeavesOpen: !this.isMobile(),

      sickLeaves: [],
      newSickLeave: {
        employeeId: this.employeeId
      }
    };
  },

  mounted() {
    this.loadSickLeaves();
  },

  methods: {
    isMobile() {
      return window.innerWidth <= 768;
    },

    loadSickLeaves() {
      Api.sickLeavesByEmployee(this.employeeId).then(
          (resp) => (this.sickLeaves = resp.data)
      );
    },

    resetNewSickLeave() {
      this.newSickLeave = {
        employeeId: this.employeeId
      };
    },

    async saveNewSickLeave() {
      await Api.saveSickLeave(this.newSickLeave);
      this.resetNewSickLeave();
      this.loadSickLeaves();
    },

    async deleteSickLeave(id) {
      await Api.deleteSickLeave(id);
      this.loadSickLeaves();
    }
  },
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}

.hidden {
  display: none !important;
}

#employee-sick-leave-container.employee-sick-leave {
  color: #252734;
  padding-left: 0;
  padding-right: 0;
}

.employee-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 24px;
  align-items: start;
}

.employee-section-card {
  border: 1px solid #AEBFC7;
  border-radius: 32px;
  background: rgba(255, 255, 255, 0.74);
  box-shadow: 0 20px 40px rgba(37, 39, 52, 0.08);
  padding: 28px;
}

.employee-section-header {
  margin-bottom: 18px;
}

.employee-section-title {
  color: #252734;
  font-family: JumperBold;
  font-size: 24px;
  line-height: 1.2;
  margin: 0;
}

.employee-section-toggle {
  align-items: center;
  background: transparent;
  border: 0;
  color: #252734;
  display: flex;
  font-family: JumperBold;
  font-size: 22px;
  justify-content: space-between;
  padding: 0;
  text-align: left;
  width: 100%;
}

.employee-section-toggle:focus {
  border-radius: 16px;
  box-shadow: 0 0 0 3px rgba(178, 236, 93, 0.7);
  outline: none;
}

.employee-fields-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 20px;
}

.employee-field-full {
  grid-column: 1 / -1;
}

.data-wrapper {
  min-height: auto;
}

.employee-field-title {
  color: #252734;
  display: block;
  font-family: JumperBold;
  font-size: 12px;
  line-height: 1.25;
  margin: 0 0 8px !important;
  padding-left: 20px;
}

.employee-field-hint {
  color: #252734;
  display: block;
  font-family: JumperThin;
  font-size: 12px;
  line-height: 1.25;
  margin-bottom: 4px;
  padding-left: 20px;
}

.employee-form-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 18px;
}

.employee-table-wrapper {
  border-radius: 24px;
  overflow: hidden;
}

#employee-sick-leave-container.employee-sick-leave input,
#employee-sick-leave-container.employee-sick-leave select,
#employee-sick-leave-container.employee-sick-leave .custom-select {
  background: #ffffff !important;
  border: 1px solid #AEBFC7 !important;
  border-radius: 32px !important;
  box-shadow: 0 10px 24px rgba(37, 39, 52, 0.09) !important;
  color: #252734 !important;
  font-family: Poppins, sans-serif !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  min-height: 42px;
  width: 100% !important;
}

#employee-sick-leave-container.employee-sick-leave input::placeholder,
#employee-sick-leave-container.employee-sick-leave select option {
  font-family: Poppins, sans-serif !important;
  font-weight: 400 !important;
}

#employee-sick-leave-container.employee-sick-leave input:focus,
#employee-sick-leave-container.employee-sick-leave select:focus,
#employee-sick-leave-container.employee-sick-leave .custom-select:focus-within {
  border-color: #5bb65d !important;
  box-shadow: 0 0 0 3px rgba(178, 236, 93, 0.35), 0 10px 24px rgba(37, 39, 52, 0.09) !important;
  outline: none;
}

#employee-sick-leave-container.employee-sick-leave .row {
  margin-left: -8px;
  margin-right: -8px;
}

#employee-sick-leave-container.employee-sick-leave .row > [class*="col-"] {
  padding-left: 8px;
  padding-right: 8px;
}

#employee-sick-leave-container.employee-sick-leave .btn-light {
  align-items: center;
  background: #ffffff !important;
  border: 1px solid #AEBFC7 !important;
  border-radius: 999px !important;
  box-shadow: 0 8px 18px rgba(37, 39, 52, 0.08);
  display: inline-flex;
  justify-content: center;
  min-height: 38px;
}

#employee-sick-leave-container.employee-sick-leave .text-danger {
  color: #9f1d1d !important;
  font-size: 12px;
}

.employee-table-wrapper ::v-deep table {
  margin-bottom: 0;
}

.employee-table-wrapper ::v-deep thead th {
  border-bottom: 1px solid #AEBFC7;
  border-top: 0;
  color: #252734;
  font-family: JumperBold;
  font-size: 12px;
  line-height: 1.25;
  vertical-align: middle;
}

.employee-table-wrapper ::v-deep tbody td {
  border-top: 0;
  color: #252734;
  font-family: Poppins, sans-serif;
  font-size: 12px;
  vertical-align: middle;
}

.employee-table-wrapper ::v-deep tbody tr:not(:last-child) td {
  border-bottom: 1px solid rgba(174, 191, 199, 0.45);
}

.employee-table-wrapper ::v-deep tbody tr.table-striped,
.employee-table-wrapper ::v-deep tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.55);
}

@media (min-width: 769px) {
  .employee-section-body.collapse:not(.show) {
    display: block !important;
    height: auto !important;
    visibility: visible !important;
  }
}

@media (max-width: 768px) {
  #employee-sick-leave-container.employee-sick-leave {
    padding-top: 16px !important;
  }

  .employee-layout,
  .employee-fields-grid {
    grid-template-columns: 1fr;
  }

  .employee-layout {
    gap: 16px;
  }

  .employee-section-card {
    border-radius: 28px;
    padding: 20px;
  }

  .employee-form-actions {
    justify-content: flex-start;
  }
}
</style>
